<script>
import TextEllipsis from "@/components/commonComponents/TextEllipsis.vue";
import VDataTableCustom from "@/components/VDataTable/VDataTableCustom.vue";
import BusinessProcess from "@/mixins/BusinessProcess";

export default {
    name: "VDataTableQuotes",
    components: {
        VDataTableCustom,
        TextEllipsis,
    },
    mixins: [
        BusinessProcess
    ],
    inheritAttrs: false,
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id',
                    width: 100,
                    // filterComponent: 'VDataTableCustomHeaderFiltersText',
                    tooltip: 'Идентификатор в системе учета ESS',
                },
                {
                    text: '&#9776;',
                    align: 'start',
                    sortable: true,
                    value: 'language',
                    width: 50,
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    filterLabel: 'Язык',
                    tooltip: 'Язык',
                },
                {
                    text: 'Сессия',
                    align: 'start',
                    sortable: true,
                    value: 'session_name',
                    width: 100,
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                },
                {
                    text: 'Спикер',
                    align: 'start',
                    sortable: true,
                    value: 'speaker_name',
                    width: 100,
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                },
                // {
                //     text: 'Должность',
                //     align: 'start',
                //     sortable: true,
                //     value: 'speaker_position',
                //     width: 300,
                //     filterComponent: 'VDataTableCustomHeaderFiltersText',
                // },
                {
                    text: 'Текст',
                    align: 'start',
                    sortable: true,
                    value: 'text',
                    cellClass: 'text',
                    // filterComponent: 'VDataTableCustomHeaderFiltersText',
                },
                {
                    text: 'БП',
                    align: 'start',
                    sortable: true,
                    value: 'approve_mask',
                    cellClass: 'status-field',
                    // filterFieldClass: 'status-field',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    filterComponentProps: {
                        /**
                         * @TODO Получается несколько одинаковых значений?
                         */
                        mapValuesFn: this.getBusinessProcessState,
                        itemTextWithHtml: true,
                    },
                    filterLabel: 'Состояние бизнес-процесса',
                    tooltip: 'Состояние бизнес-процесса',
                    width: 150,
                },
                {
                    text: 'Создано',
                    align: 'center',
                    sortable: true,
                    value: 'created_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
                {
                    text: 'Создано',
                    align: 'center',
                    sortable: true,
                    value: 'created_by_name',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    width: 120,
                },
                {
                    text: 'Обновлено',
                    align: 'center',
                    sortable: true,
                    value: 'updated_at',
                    filterComponent: 'VDataTableCustomHeaderFiltersDate',
                    width: 120,
                },
                {
                    text: 'Обновлено',
                    align: 'center',
                    sortable: true,
                    value: 'updated_by_name',
                    filterComponent: 'VDataTableCustomHeaderFiltersAutocomplete',
                    width: 120,
                },
            ],
        };
    },
    computed: {},
    methods: {
        getItemClass(item) {
            return item.is_declined ? {
                'is_declined': !!item.is_declined,
            } : this.getBusinessProcessState(item.approve_mask, "class");
        }
    },
}
</script>

<template>
    <v-data-table-custom
        v-bind="$attrs"
        v-on="$listeners"
        :headers="headers"
        :item-class="getItemClass"
        item-key="id"
        permissions-by-module="quotes"
    >
        <template v-slot:item.speaker_position="{value}">
            <text-ellipsis :multiline="2">
                {{ value }}
            </text-ellipsis>
        </template>
        <template v-slot:item.session_name="{value}">
            <text-ellipsis :multiline="4">
                {{ value }}
            </text-ellipsis>
        </template>
        <template v-slot:item.text="{value}">
            <text-ellipsis :multiline="4">
                {{ value }}
            </text-ellipsis>
        </template>
    </v-data-table-custom>
</template>

<style scoped lang="css">
/**
Неинтересно...
 */
.v-data-table ::v-deep tr td.text {
    padding-top: 4px;
    padding-bottom: 4px;
}

::v-deep tr.is_declined {
    color: silver;
    text-decoration: line-through;
}

::v-deep tr.bp_is_new {
    color: silver;
}

::v-deep tr.bp_is_in_progress {
    font-weight: normal;
}

::v-deep tr.bp_approved_by_editor,
::v-deep tr.bp_approved_by_approver,
::v-deep tr.bp_approved_by_moderator,
::v-deep tr.bp_is_approved {
    font-weight: 500;
}

::v-deep tr.bp_is_declined {
    font-weight: 500;
}

::v-deep tr.bp_is_declined .text {
    color: darkred;
}

::v-deep tr.bp_is_published .text {
    color: darkgreen;
}

::v-deep .status-field {
    width: 150px;
    max-width: 150px;
}
</style>
